import processSteps from '../../data/tiktokProcess.json';


export default function Section9() {
    


    return (
        <div className="Section16 py-[50px] md:py-[30px] bg-white">
            {/* Section Heading */}
            <div className="text-center mb-16 max-w-4xl mx-auto">
                <h2 className="text-[26px] md:text-[30px] font-bold text-[#151515] leading-[32px] md:leading-[41px]">
                    Our <span className="text-[#DA2128]">TikTok Marketing Process</span>
                </h2>
                <p className="mt-6 text-[#555] text-[16px] md:text-[18px] max-w-[700px] mx-auto">
                    Our process is simple, transparent, and built to deliver real growth.
                </p>
            </div>

            {/* Process Steps Grid */}
            <div className="flex flex-wrap justify-center gap-8 md:gap-12 w-[90%] md:w-[85%] mx-auto">
                {processSteps.map((step, index) => (
                    <div
                        key={index}
                        className={`p-6 rounded-2xl shadow-md text-left transition 
        ${index % 2 === 0
                                ? "bg-[#E42E35] text-white"
                                : "bg-white text-[#151515] border border-gray-200"
                            } 
        w-full sm:w-[45%] md:w-[30%]`}
                    >
                        <h3 className="text-[18px] md:text-[20px] font-bold mb-3">
                            {step.title}
                        </h3>
                        <p className="text-[14px] md:text-[15px] leading-[22px]">
                            {step.description}
                        </p>
                    </div>
                ))}
            </div>

        </div>
    );
}
